// Draait als extern bestand met defer, dus document.currentScript is hier null.
// Daarom pakken we elke .hv-pp op de pagina op in plaats van de eigen sectie.
document.querySelectorAll('.hv-pp').forEach(function (pp) {

  // Galerij. Twee standen, want het gebaar verschilt per apparaat:
  //
  //   desktop  een stapel foto's, je klikt een miniatuur aan
  //   telefoon een rij die je opzij swipet, met scroll-snap
  //
  // De telefoonstand laat de browser het schuiven doen. Een swipe namaken met
  // touchstart/touchmove voelt altijd net verkeerd: geen vaart, geen rubber aan
  // de randen, en het vecht met verticaal scrollen.
  //
  // In de rijstand mag hidden niets meer verbergen — alle foto's staan naast
  // elkaar — dus dat attribuut gaat er dan af en komt terug zodra je op een
  // breed scherm komt.
  var thumbs = Array.prototype.slice.call(pp.querySelectorAll('.thumb'));
  var shots  = Array.prototype.slice.call(pp.querySelectorAll('.shot'));
  var stage  = pp.querySelector('.stage');
  var rail   = pp.querySelector('.rail');
  var smal   = window.matchMedia('(max-width:980px)');

  function markeer(i) {
    thumbs.forEach(function (t) {
      var aan = t.dataset.i === String(i);
      t.setAttribute('aria-current', aan ? 'true' : 'false');
      // De strip is smaller dan het aantal foto's; de actieve miniatuur mag niet
      // buiten beeld blijven staan als je met swipen van foto wisselt.
      if (aan && rail && rail.scrollWidth > rail.clientWidth) {
        var r = t.offsetLeft - (rail.clientWidth - t.offsetWidth) / 2;
        rail.scrollTo({ left: Math.max(0, r), behavior: 'smooth' });
      }
    });
  }

  function huidig() {
    for (var n = 0; n < thumbs.length; n++) {
      if (thumbs[n].getAttribute('aria-current') === 'true') return Number(thumbs[n].dataset.i);
    }
    return 0;
  }

  function zetStand() {
    var i = huidig();
    if (smal.matches) {
      shots.forEach(function (s) { s.hidden = false; });
      if (stage) stage.scrollLeft = i * stage.clientWidth;
    } else {
      shots.forEach(function (s, n) { s.hidden = n !== i; });
    }
    markeer(i);
  }

  function ga(i, direct) {
    markeer(i);
    if (smal.matches && stage) {
      stage.scrollTo({ left: i * stage.clientWidth, behavior: direct ? 'auto' : 'smooth' });
    } else {
      shots.forEach(function (s, n) { s.hidden = n !== i; });
    }
  }

  // Kleurwissel. In data-kleur staat de optiewaarde die Liquid uit de alt-tekst
  // of uit een echte variantkoppeling heeft gehaald; leeg betekent "geen kleur"
  // en dat zijn de sfeerbeelden, de infographics en de maatfoto.
  //
  // We VERBERGEN niets - we springen alleen naar de eerste foto die bij de
  // gekozen kleur hoort. Levert het niets op, dan blijft de galerij staan waar
  // hij stond; dat is beter dan naar een willekeurige foto springen.
  function naarKleur(waarden, direct) {
    var set = waarden.filter(Boolean).map(function (w) { return String(w).toLowerCase().trim(); });
    if (!set.length) return;
    // Sta je al op een foto van de gekozen kleur, dan blijft die staan. Anders
    // zou het wisselen van een ANDERE optie - een maat bijvoorbeeld - je steeds
    // terugslepen naar de eerste foto van je kleur.
    var nu = shots[huidig()];
    if (nu && nu.dataset.kleur && set.indexOf(nu.dataset.kleur) > -1) return;
    for (var n = 0; n < shots.length; n++) {
      var k = shots[n].dataset.kleur;
      if (k && set.indexOf(k) > -1) {
        ga(n, direct);
        return;
      }
    }
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { ga(Number(t.dataset.i)); });
  });

  if (stage) {
    var wacht = null;
    stage.addEventListener('scroll', function () {
      if (!smal.matches) return;
      // Pas markeren als het schuiven tot rust is gekomen, anders springt de
      // strip mee met elke tussenstand.
      clearTimeout(wacht);
      wacht = setTimeout(function () {
        var breedte = stage.clientWidth || 1;
        var pos = Math.round(stage.scrollLeft / breedte);
        if (pos < 0) pos = 0;
        if (pos > shots.length - 1) pos = shots.length - 1;
        markeer(pos);
      }, 90);
    }, { passive: true });
  }

  if (smal.addEventListener) smal.addEventListener('change', zetStand);
  else if (smal.addListener) smal.addListener(zetStand);
  zetStand();

  // Variantwissel. De varianten komen als JSON uit Liquid mee, zodat prijs en
  // beschikbaarheid kloppen zonder een extra request.
  var data = pp.querySelector('[data-variants]');
  if (!data) return;
  var variants = JSON.parse(data.textContent);
  var form     = pp.querySelector('[data-buy]');
  var input    = pp.querySelector('[data-variant-input]');
  var priceEl  = pp.querySelector('[data-price]');
  var compEl   = pp.querySelector('[data-compare]');
  var saveEl   = pp.querySelector('[data-save]');
  var ctaEl    = pp.querySelector('[data-cta-label]');
  var addLabel = ctaEl ? ctaEl.textContent : '';

  function money(cents) {
    return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // :not([data-tweede]) is essentieel. De tweede keuzelijst bij "2 stuks" is een
  // KLOON van de eerste en draagt dus hetzelfde data-opt. Zonder die uitsluiting
  // wint de laatste in de DOM en volgde de hoofdvariant - prijs en het verborgen
  // id-veld - de TWEEDE lijst in plaats van de eerste.
  function sync() {
    var chosen = [];
    pp.querySelectorAll('fieldset[data-opt]:not([data-tweede])').forEach(function (fs) {
      // Een keuzelijst bij gewone opties, gekleurde bolletjes bij Kleur. Beide
      // leveren een waarde; de rest van deze functie merkt het verschil niet.
      var picked = fs.querySelector('select') || fs.querySelector('input:checked');
      chosen[fs.dataset.opt] = picked ? picked.value : null;
      var name = pp.querySelector('[data-optname="' + fs.dataset.opt + '"]');
      if (name && picked) name.textContent = picked.value;
    });

    var match = variants.find(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    });
    if (!match) return;

    input.value = match.id;
    naarKleur(chosen);
    if (priceEl) priceEl.textContent = money(match.price);

    var sale = match.compare_at_price && match.compare_at_price > match.price;
    if (compEl) compEl.textContent = sale ? money(match.compare_at_price) : '';
    if (compEl && compEl.parentElement) compEl.parentElement.hidden = !sale;
    if (saveEl) {
      saveEl.hidden = !sale;
      // Bedrag, geen percentage: de pagina toont bij het laden ook een bedrag,
      // en anders springt de tekst van vorm zodra je een variant kiest.
      if (sale) saveEl.textContent = 'Bespaar ' + money(match.compare_at_price - match.price);
    }
    if (ctaEl) ctaEl.textContent = match.available ? addLabel : 'Uitverkocht';
    var btn = form.querySelector('.cta');
    if (btn) btn.disabled = !match.available;
  }

  pp.querySelectorAll('fieldset[data-opt]:not([data-tweede]) input, fieldset[data-opt]:not([data-tweede]) select').forEach(function (i) {
    i.addEventListener('change', sync);
  });

  // Beginstand. Komt iemand via een advertentie met ?variant= binnen op de
  // zilveren uitvoering, dan hoort daar niet de zwarte foto bij te staan.
  // Direct, zonder smooth scroll: bij het laden hoort er niets te bewegen.
  var beginwaarden = [];
  pp.querySelectorAll('fieldset[data-opt]:not([data-tweede])').forEach(function (fs) {
    var picked = fs.querySelector('select') || fs.querySelector('input:checked');
    if (picked) beginwaarden.push(picked.value);
  });
  naarKleur(beginwaarden, true);

  // Variant in de bundelkaart die aanstaat, onderaan. Hij stond eerst boven en
  // daarna onder het bundelblok, maar allebei buiten de kaart, waardoor het las
  // als een losse tweede keuze.
  //
  // De velden worden hier één keer vastgepakt en daarna steeds verplaatst, nooit
  // opnieuw gemaakt. Dat is met opzet: hun snippet kan de inhoud van een kaart
  // opnieuw opbouwen, en zou een nieuw gemaakt veld weggooien samen met de
  // gekozen variant. Nu overleven de velden dat en zet de observer ze terug.
  var velden = Array.prototype.slice.call(
    (form || document).querySelectorAll('fieldset[data-opt]')
  );

  // ─── Twee stuks, twee kleuren ───
  // Bij "2 stuks" wil iemand soms een zwarte en een zilveren, geen twee dezelfde.
  // Een regel in de winkelwagen draagt precies een variant, dus twee kleuren zijn
  // twee regels: bij het bestellen sturen we dan items[0] en items[1] in plaats van
  // een enkele id met aantal 2. Kiest de klant twee keer dezelfde kleur, dan blijft
  // het een regel met aantal 2 - dat leest netter in de winkelwagen.
  var tweede = null;

  function waardenVan(set) {
    var uit = [];
    set.forEach(function (fs) {
      var p = fs.querySelector('select') || fs.querySelector('input:checked');
      if (p) uit.push(p.value);
    });
    return uit;
  }

  function maakTweede() {
    if (tweede || !velden.length) return;
    tweede = velden.map(function (fs) {
      var kl = fs.cloneNode(true);
      kl.dataset.tweede = '1';
      // Andere veldnamen, anders sturen twee lijsten dezelfde naam mee.
      kl.querySelectorAll('select').forEach(function (sel) { sel.name = 'tweede-' + sel.name; });
      // Net als bij de eerste set: een klik hier mag de bundelkeuze niet omzetten.
      kl.addEventListener('click', function (e) { e.stopPropagation(); });
      // cloneNode kopieert GEEN luisteraars, dus de tweede lijst deed eerst niets:
      // je koos een andere kleur en de foto bleef staan. Hij hangt bewust niet aan
      // sync(): de tweede kleur bepaalt de tweede winkelwagenregel, niet de prijs
      // of het id-veld. Alleen de galerij mag mee.
      kl.querySelectorAll('select, input').forEach(function (el) {
        el.addEventListener('change', function () { naarKleur(waardenVan(tweede)); });
      });
      return kl;
    });
  }

  function zetLabel(fs, voorvoegsel) {
    var l = fs.querySelector('.kieslabel');
    if (!l) return;
    if (!l.dataset.basis) l.dataset.basis = l.textContent;
    l.textContent = voorvoegsel ? voorvoegsel + ' ' + l.dataset.basis.toLowerCase() : l.dataset.basis;
  }

  function variantVan(set) {
    var keuze = [];
    set.forEach(function (fs) {
      var p = fs.querySelector('select') || fs.querySelector('input:checked');
      keuze[fs.dataset.opt] = p ? p.value : null;
    });
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return o === keuze[i]; });
    }) || null;
  }

  function plaatsVariant() {
    if (!form || !velden.length) return;
    var wrap = form.querySelector('.hvb-wrap');
    if (!wrap) return;
    var actief = wrap.querySelector('.hvb-card.is-actief') || wrap.querySelector('.hvb-card');
    if (!actief) return;

    var twee = actief.getAttribute('data-qty') === '2';
    if (twee) maakTweede();
    var wil = twee ? velden.concat(tweede) : velden;

    // Al op zijn plek? Dan niets doen, anders zet de observer zichzelf aan het
    // werk bij elke verplaatsing die hij zelf veroorzaakt. De vergelijking gaat
    // over de hele rij en niet over het laatste veld alleen: met een tweede set
    // erachter is dat laatste veld van set 1 niet meer het laatste kind, en dan
    // klopte de afslag nooit meer en bleef de observer rondjes draaien.
    var staat = Array.prototype.slice.call(actief.querySelectorAll('fieldset[data-opt]'));
    if (staat.length === wil.length && staat.every(function (fs, i) { return fs === wil[i]; })) return;

    if (tweede && !twee) {
      tweede.forEach(function (fs) { if (fs.parentNode) fs.parentNode.removeChild(fs); });
    }
    wil.forEach(function (fs) { actief.appendChild(fs); });
    velden.forEach(function (fs) { zetLabel(fs, twee ? '1e' : ''); });
    if (twee) tweede.forEach(function (fs) { zetLabel(fs, '2e'); });
  }

  // Een klik op de lijst mag de bundelkeuze niet omzetten: de lijst ligt binnen
  // de kaart, en die kaart luistert zelf ook op klikken.
  velden.forEach(function (fs) {
    fs.addEventListener('click', function (e) { e.stopPropagation(); });
  });

  plaatsVariant();

  if (form) {
    form.addEventListener('submit', function (e) {
      var kaart = form.querySelector('.hvb-card.is-actief');
      if (!kaart || kaart.getAttribute('data-qty') !== '2') return;
      if (!tweede || !tweede.length) return;

      var een = variantVan(velden);
      var twee = variantVan(tweede);
      // Niets te doen als de kleur gelijk is, of als een combinatie niet bestaat:
      // dan gaat het formulier gewoon zoals het was, met aantal 2.
      if (!een || !twee || een.id === twee.id) return;

      e.preventDefault();
      var idVeld = form.querySelector('[name="id"]');
      var aantal = form.querySelector('input[name="quantity"]');
      // De naam eraf halen in plaats van het veld weggooien: het bundelscript
      // zoekt deze velden later terug en zou ze anders opnieuw aanmaken.
      if (idVeld) idVeld.removeAttribute('name');
      if (aantal) aantal.removeAttribute('name');

      [een.id, twee.id].forEach(function (vid, n) {
        [['id', vid], ['quantity', 1]].forEach(function (paar) {
          var h = document.createElement('input');
          h.type = 'hidden';
          h.name = 'items[' + n + '][' + paar[0] + ']';
          h.value = paar[1];
          form.appendChild(h);
        });
      });
      form.submit();
    });
  }

  if (form && window.MutationObserver) {
    // childList voor als het bundelblok later komt of opnieuw wordt opgebouwd,
    // attributes voor als je een ander aantal kiest: dan verhuist is-actief en
    // moet de lijst mee.
    new MutationObserver(plaatsVariant).observe(form, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class']
    });
  }
});
